import { render, staticRenderFns } from "./descriptionSpecialtyAlumni.vue?vue&type=template&id=56b37efb&scoped=true&"
import script from "./descriptionSpecialtyAlumni.vue?vue&type=script&lang=js&"
export * from "./descriptionSpecialtyAlumni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b37efb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
